// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import Icon_check from '../../img/icons/16/check.svg';
import Icon_x from '../../img/icons/16/close.svg';
import Logo_toolip from '../../img/competitors/toolip_combined.svg';
import {Input} from '../../../../hola/pub/lib/input';
import styles from './comparison_table.module.less';
import {i_company_name} from './vs_toolip';

const features_map = {
    1: 'Global Residential IPs',
    2: 'Advanced Session Control',
    3: 'Pay-As-You-Go Pricing',
    4: 'Real-Time Analytics',
    5: '24/7 Customer Support'
};

interface i_comparison_props {
    company?: i_company_name;
    features?: string;
    start_price?: string;
    toolip_price?: string;
    full_logo?: string;
    cta?: string;
}

interface i_col_data {
    provider: 'titles' | 'toolip' | string;
    icon: string | null;
    features: string;
    price: string;
    btn?: JSX.Element;
    cta?: string;
}

type i_col_type = 'titles' | 'toolip' | 'company';

const Col = ({data, type}: {data: i_col_data, type: i_col_type})=>{
    const {theme} = useContext(Settings_context);
    const features_arr = data.features.split(',').map(Number);
    return <div className={cn(styles.col, styles[type])}>
      <div className={styles.col_header}>
        {type == 'company' ?
          <img src={data.icon}/> :
          type == 'toolip' ? <Logo_toolip/> : null}
      </div>
      {Object.entries(features_map).map(([key, title])=>
        <div key={key} className={cn(styles.col_cell, theme.p14, theme.reg)}>
          {type == 'titles' ? title :
            features_arr.includes(Number(key)) ?
              <Icon_check/> :
              <Icon_x className={styles.inactive}/>}
        </div>
      )}
      <div className={styles.col_footer}>
        {type == 'titles' ?
          <div className={cn(styles.price, theme.p14, theme.reg)}>
            Pricing Starting At
          </div>
          :
          <>
            <p className={cn(type == 'toolip' ? [theme.p16, theme.color_n700] :
              [theme.p14, theme.color_n500], theme.med)}>
              {data.price}</p>
            {type == 'toolip' &&
              <Button caption={data.cta} color='black' round={false}
                to='/dashboard' fit cls={styles.button}/>}
          </>
        }
      </div>
    </div>;
};

export const Comparison_table = (props: i_comparison_props)=>{
    const {theme} = useContext(Settings_context);
    const toolip_data: i_col_data = {
        provider: 'toolip',
        icon: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'toolip_combined.svg',
        features: '1,2,3,4,5',
        price: props.toolip_price || '$0.50/GB',
        cta: props.cta || 'Try Toolip for Free'
    };
    const titles_data: i_col_data = {
        provider: 'titles',
        icon: null,
        features: '',
        price: ''
    };
    const company_data: i_col_data = {
        provider: 'company',
        icon: props.full_logo || '',
        features: props.features || '',
        price: props.start_price || ''
    };
    return <div className={styles.comparison}>
      <h2 className={theme.h2}>Why choose Toolip.io?</h2>
      <div className={styles.table}>
        <Col data={titles_data} type="titles"/>
        <Col data={toolip_data} type="toolip"/>
        <Col data={company_data} type="company"/>
      </div>
    </div>;
};

export const Comparison_table_editor = ({value, on_change})=>{
  return <div>
    <Input
      value={value.features || ''}
      on_change={v=>on_change({...value, features: v})}
      label='Features (enter numbers separated by commas, e.g. "1,2,5")'
    />
    <Input
      value={value.start_price || ''}
      on_change={v=>on_change({...value, start_price: v})}
      label='Starting Price'
    />
    <Input
      value={value.toolip_price || ''}
      on_change={v=>on_change({...value, toolip_price: v})}
      label='Toolip start Price'
    />
    <Input
      value={value.full_logo || ''}
      on_change={v=>on_change({...value, full_logo: v})}
      label='Company Logo URL'
    />
    <Input
      value={value.cta || ''}
      on_change={v=>on_change({...value, cta: v})}
      label='Toolip cta'
    />
  </div>;
};
